// import { create } from 'zustand'

// const useProfileStore = create((set) => ({
//     profile: null,
//     // isLoading: false,
//     error: null,

//     setProfile: (data) => set({ profile: data }),
    
//     clearProfile: () => set({ profile: null }),

//     // setLoading: (status) => set({ isLoading: status }),

//     setError: (error) => set({ error }),

//     updateProfile: (data) => set((state) => ({
//         profile: { ...state.profile, ...data }
//     })),

//     resetStore: () => set({
//         profile: null,
//         // isLoading: false,
//         error: null
//     })
// }))

// export default useProfileStore

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { devtools } from "zustand/middleware";

const useProfileStore = create(
  persist(
  devtools((set) => ({
    profile: [],
    saveprofile: (profile) => set({ profile }),
  })),
  {
    name: 'ProfileStore',
  }
)
);

export default useProfileStore